import { TipoConteudoComponent } from './../caixa/tipo-conteudo/tipo-conteudo.component';
import { TipoCaixaComponent } from './../caixa/tipo-caixa/tipo-caixa.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { GerarRgsComponent } from '../caixa/gerar-rgs/gerar-rgs.component';
import { NumeracaoCaixasComponent } from '../caixa/gerar-numeracao/numeracao-caixas/numeracao-caixas.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon'; 
@Component({
  selector: 'app-sidenav-caixa',
  templateUrl: './sidenav-caixa.component.html',
  styleUrls: ['./sidenav-caixa.component.scss']
})
export class SidenavCaixaComponent implements OnInit {

  public arrayString: string;
  public superUser = false;
  public createEmpresa = false;
  public editEmpresa = false;
  public deleteEmpresa = false;
  public viewEmpresa = false;
  public semPermisao = true;

  constructor(public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    iconRegistry: MatIconRegistry
  ) {
    iconRegistry.addSvgIcon('numeroIcon', sanitizer.bypassSecurityTrustResourceUrl('../../../assets/icons/Nova_numeracao.svg'));
   }

  ngOnInit() {
    this.getAuthority();
  }

  getAuthority() {
    this.getItemAuthority('authority');
      if (this.arrayString.includes('LIST_CAIXA')) {
        this.viewEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('DELETE_CAIXA')) {
        this.deleteEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('EDIT_CAIXA')) {
        this.editEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('ADD_CAIXA')) {
        this.createEmpresa = true;
        this.semPermisao = false;
      }
      if (this.arrayString.includes('SUPER_USER')) {
        this.superUser = true;
        this.semPermisao = false;
      }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
        try {
            const bytes = CryptoJS.AES.decrypt(store, sessionStorage.getItem('ticket-ECM'));
            this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return this.arrayString;
        } catch (e) {
            sessionStorage.clear();
        }
    }

    return null;
  }

  gerarRgs(): void {
    const dialogRef = this.dialog.open(GerarRgsComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`The dialog was closed - ${result}`);
    });
  }

  gerarNrs(): void {
    const dialogRef = this.dialog.open(NumeracaoCaixasComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`The dialog was closed - ${result}`);
    });
  }

  openDialogTipoCaixa() {
    const dialogRef = this.dialog.open(TipoCaixaComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openDialogTipoConteudo() {
    const dialogRef = this.dialog.open(TipoConteudoComponent, {
      width: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }


}





// WEBPACK FOOTER //
// /app/src/app/components/sidenav-caixa/sidenav-caixa.component.ts